import React from 'react'
import intl from 'react-intl-universal'
import { AuthenticationInputPropTypes } from 'utils/prop_types/AuthenticationInput'
import { Input, ListGroup, ListGroupItem } from 'components/qstrap'
import ValidationIcon from 'components/shared/input/ValidationIcon'

export default class RadioInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      value: props.defaultValue,
    }

    this.onChange = this.onChange.bind(this)
  }

  onChange(e) {
    this.setState({
      value: e.target.value,
    })
    this.props.handleChange(e)
  }

  render() {
    const {
      options,
      translationKey,
      valid,
    } = this.props

    return (
      <div>
        <ListGroup>
          {
            options.map((option) => {
              const checked = this.state.value === option
              return (
                <ListGroupItem className="radio" key={option}>
                  <label>
                    <Input type="radio" name={option} onChange={this.onChange} value={option} checked={checked} />
                    <span className={`cr ${checked ? 'checked' : ''}`}>
                      <i className="cr-icon" />
                    </span>
                    {translationKey ? (
                      intl.get(`${translationKey}.${option}`)
                    ) : (
                      option
                    )}
                  </label>
                </ListGroupItem>
              )
            })
        }
        </ListGroup>
        <ValidationIcon valid={valid} enabled />
      </div>
    )
  }
}

RadioInput.propTypes = AuthenticationInputPropTypes
RadioInput.defaultProps = {
  type: 'text',
  validations: [],
  selectOptions: [],
}

